import { Flipped, Flipper } from 'react-flip-toolkit';
import { FaMedal } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

import classes from './Group.module.css';

import { useAppSelector } from '../../store/hooks';

type GroupProps = {
  place: number;
  id: string;
  name: string;
  score: number;
  maxScore: number;
};

type PlaceIconProps = {
  place: number;
};

const PlaceIcon = ({ place }: PlaceIconProps) => {
  let innerElement = null;
  if (place === 1) {
    innerElement = <FaMedal color={'darkgoldenrod'} />;
  } else if (place === 2) {
    innerElement = <FaMedal color={'gray'} />;
  } else if (place === 3) {
    innerElement = <FaMedal color={'saddlebrown'} />;
  } else {
    innerElement = <p>{`${place}`}</p>;
  }
  return <div className={classes.place}>{innerElement}</div>;
};

const Group = (props: GroupProps) => {
  const navigate = useNavigate();
  const loggedIn = useAppSelector(state => state.auth.loggedIn);

  const extraBarStyle: React.CSSProperties = {
    width: `${(props.score / props.maxScore) * 100}%`,
  };

  const innerBarClickHandler = () => {
    if (loggedIn) {
      navigate(`/afterwork/edit/${props.id}`);
    }
  };

  const innerBarClasses = `${classes.innerBar} ${loggedIn ? classes.clickable : ''}`;

  return (
    <Flipper flipKey={props.score} className={classes.container}>
      <PlaceIcon place={props.place} />
      <div className={classes.outerBar}>
        <Flipped flipId={props.place} spring="wobbly">
          <div style={extraBarStyle} className={innerBarClasses} onClick={innerBarClickHandler}>
            <p className={classes.name}>{props.name}</p>
          </div>
        </Flipped>
      </div>
      <p className={classes.score}>{`${props.score}`}&#127866;</p>
    </Flipper>
  );
};

export default Group;
